// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3PlLH","amount":"Amount_amount__InpmW","tip":"Amount_tip__1iPKc","tipHeader":"Amount_tipHeader__1Pa-1","tipsWrap":"Amount_tipsWrap__2YyGw"};